import { Comparator } from '../../../../constants/types';

// Comparator conversion maps
export const COMPARATOR_DESCRIPTION_MAP: Record<Comparator, string> = {
  '=': 'equal to',
  '>': 'greater than',
  '>=': 'greater than or equal to',
  '<': 'less than',
  '<=': 'less than or equal to',
  '!=': 'not equal to',
};

export default { COMPARATOR_DESCRIPTION_MAP };
